import React from 'react';
const SvgOds = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M44 38H4V10h32l8 8v1z" />
      <path fill="#217346" d="M14 35H7v-2h7zM14 31H7v-2h7zM14 27H7v-2h7zM14 19H7v-2h7zM14 15H7v-2h7zM14 23H7v-2h7z" />
      <path
        fill="#C8C8C8"
        d="M23 35h-7v-2h7zM23 31h-7v-2h7zM23 27h-7v-2h7zM23 19h-7v-2h7zM23 15h-7v-2h7zM23 23h-7v-2h7zM32 35h-7v-2h7zM32 31h-7v-2h7zM32 27h-7v-2h7zM32 19h-7v-2h7zM32 15h-7v-2h7zM32 23h-7v-2h7zM41 35h-7v-2h7zM41 31h-7v-2h7zM41 27h-7v-2h7zM36 19h-1.896v-2H36zM36 15h-1.896v-2H36zM41 23h-7v-2h7z"
      />
      <path fill="#949494" d="M36 9H3v30h42V18l-9-9zm0 1.542L43.5 18H36v-7.458zM44 38H4V10h31v9h9v19z" />
      <linearGradient id="ods_svg__a" gradientUnits="userSpaceOnUse" x1={5.721} y1={6.716} x2={37.847} y2={45.002}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#ods_svg__a)" d="M45 18l-9-9H3v30h42V18z" />
      <linearGradient id="ods_svg__b" gradientUnits="userSpaceOnUse" x1={34.068} y1={18.432} x2={39.735} y2={12.765}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#ods_svg__b)" d="M12 9v1h23v9h9v20h1V18l-9-9z" />
      <linearGradient id="ods_svg__c" gradientUnits="userSpaceOnUse" x1={39.5} y1={21.906} x2={39.5} y2={19.087}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#ods_svg__c)" d="M35 19h9v3h-9z" />
    </svg>
  );
});
export default SvgOds;
SvgOds.iconName = 'ods';
SvgOds.displayName = 'SvgOds';
